module.exports = __webpack_public_path__ + "img/icon-navigation-add-cropped.fd973ae4.svg";